import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getClubSwimAThonLeaderboard from './GetClubSwimAThonLeaderboardData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubSwimAThonLeaderboardData = {
  INITIAL_STATE,
  getClubSwimAThonLeaderboard
};

export default ClubSwimAThonLeaderboardData;